export  const theme = {
    rainbow: {
        palette: {
            brand: '#2d2180',
        },
    },
};